import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user from '@/store/modules/user';
import { auth } from '@/store/auth.module';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  key: 'gosaas-owner-store',
  modules: ['websocket']
});

const store = new Vuex.Store({
  modules: {
    auth,
    user,
  },
  strict: debug
});

vuexLocal.plugin(store);

export default store


// WEBPACK FOOTER //
// ./src/store/main.js